import React, { useEffect, useCallback, useMemo } from 'react';
import pt from 'prop-types';
import { Button } from 'antd';
import { Field } from 'redux-form';
import get from 'lodash/get';

import { adminFopsColumns } from 'utils/tablesConfig';
import validators from 'utils/redux-form/validators';
import { Page, ReduxModalForm, ReduxInputs, Table } from 'components/shared';

import './Fops.scss';

const Fops = (props) => {
    const { actions, fops, filteredFops } = props;
    const { fetchFops, toggleEditModal, submitEdit, edit } = actions;
    const { loading, modals } = fops;

    useEffect(() => {
        fetchFops();
    }, []);

    const getEditFormIntialValues = useCallback((modalPayload) => {
        if (modalPayload.new) {
            return {
                name: '',
            };
        }
        return {
            name: modalPayload.name,
        };
    }, []);

    const openCreateModal = useCallback(() => {
        edit({ new: true });
    }, []);

    const newModalOpen = useMemo(() => !!get(modals, 'editFop.data.new'), [modals]);

    return (
        <Page className="fop-admin wide-table">
            <ReduxModalForm
                formId="adminFopsEdit"
                title={newModalOpen ? 'Створення ФОП' : 'Редагування ФОП'}
                submitButtonText={newModalOpen ? 'Створити' : 'Редагувати'}
                optionsPath="adminFops.modals.editFop"
                getIntialValues={getEditFormIntialValues}
                toggler={toggleEditModal}
                onSubmit={submitEdit}
            >
                <Field
                    name="name"
                    component={ReduxInputs.Text}
                    id="fop_name"
                    label="Назва"
                    validate={[validators.required]}
                />
            </ReduxModalForm>

            <div className="container">
                <Button onClick={openCreateModal} style={{ marginBottom: '20px' }}>Додати ФОП</Button>
            </div>

            <Table
                rowKey="id"
                rowClassName={record => record.className}
                data={filteredFops}
                loading={loading}
                paginationPath={false}
                columns={adminFopsColumns}
            />
        </Page>
    );
};

Fops.propTypes = {
    actions: pt.shape({}).isRequired,
};

Fops.defaultProps = {
};

export default Fops;
